import React, { useEffect, useState } from "react";

import dayjs from "dayjs";

import { ModernTenantModal } from "js/components/Tenants/ModernTenantModal";
import { TenantDetails } from "js/components/Tenants/TenantReportDetails/typing";
import { Button } from "js/components/ui/button";
import {
  DescriptionList,
  DescriptionItem,
} from "js/components/ui/description-list";
import { toast } from "../../../../utils/toast";
import { toTitleCase } from "../../../../utils/utils";

interface TenantReportDetailsProps {
  tenant: TenantDetails;
  onUpdate: (updatedTenant: TenantDetails) => void;
  folio?: string;
  isEditable: boolean;
  isModalOpen?: boolean;
  onModalOpenChange?: (open: boolean) => void;
}

const TenantDetailsComponent: React.FC<TenantReportDetailsProps> = ({
  tenant,
  onUpdate,
  isEditable,
  isModalOpen,
  onModalOpenChange,
}) => {
  const [isLegalPerson, setIsLegalPerson] = useState<boolean>(false);
  const [internalModalOpen, setInternalModalOpen] = useState(false);
  const hasExternalModalControl =
    isModalOpen !== undefined && onModalOpenChange !== undefined;
  const isModalVisible = hasExternalModalControl
    ? isModalOpen
    : internalModalOpen;
  const setIsModalVisible = hasExternalModalControl
    ? onModalOpenChange
    : setInternalModalOpen;

  useEffect(() => {
    setIsLegalPerson(tenant?.legal_type == "Legal");
  }, [tenant]);

  const handleSuccess = (updatedData?: any) => {
    toast.success("Datos actualizados");
    if (updatedData) {
      const { legal_type: _ignoredLegalType, ...sanitizedData } =
        updatedData ?? {};
      const updatedTenant = {
        ...tenant,
        ...sanitizedData,
      };
      onUpdate(updatedTenant);
    }
    setIsModalVisible(false);
  };

  const fullName = toTitleCase(
    `${tenant?.name} ${tenant?.first_surname ?? ""} ${tenant?.second_surname ?? ""}`.trim(),
  );

  return (
    <>
      {isEditable && !hasExternalModalControl && (
        <div className="mb-4 flex justify-end">
          <Button variant="ghost" size="sm" onClick={() => setIsModalVisible(true)}>
            Editar
          </Button>
        </div>
      )}

      <DescriptionList>
        <DescriptionItem
          label={`Nombre${isLegalPerson ? " del representante legal" : ""}`}
          copyable
        >
          {fullName}
        </DescriptionItem>
        <DescriptionItem label="Correo" copyable>
          {tenant?.email}
        </DescriptionItem>
        <DescriptionItem label="Teléfono" copyable>
          {tenant?.phone_number
            ? `${tenant?.dial_code ?? ""} ${tenant.phone_number}`
            : null}
        </DescriptionItem>
        <DescriptionItem label="RFC" copyable>
          {tenant?.rfc ?? null}
        </DescriptionItem>
        <DescriptionItem label="Fecha de Nacimiento">
          {tenant?.birth_date
            ? dayjs(tenant.birth_date).format("DD/MM/YYYY")
            : null}
        </DescriptionItem>
        <DescriptionItem label="CURP" copyable>
          {tenant?.curp ?? null}
        </DescriptionItem>
      </DescriptionList>

      <ModernTenantModal
        isOpen={isModalVisible}
        onOpenChange={setIsModalVisible}
        onSuccess={handleSuccess}
        selectedTenant={tenant}
      />
    </>
  );
};

export default TenantDetailsComponent;
